import { SVGProps } from 'react';

export const IconSend = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='none' {...props}>
      <path
        d='M18.7358 3.11356L2.43915 12.5125C1.80275 12.878 1.88362 13.7638 2.5165 14.0309L6.25401 15.5985L16.3555 6.69877C16.5489 6.52654 16.8231 6.79016 16.6579 6.99051L8.18781 17.3068V20.1363C8.18781 20.9658 9.18987 21.2927 9.68211 20.6917L11.9148 17.9746L16.2957 19.8094C16.795 20.0203 17.3646 19.7075 17.456 19.1697L19.9875 3.98526C20.1071 3.27524 19.3441 2.76207 18.7358 3.11356Z'
        fill='currentColor'
      />
    </svg>
  );
};
